import { addNotify } from 'features/notify';

const actionTypes = {
  ACTION_PROCESSING: 'betHistory/ACTION_PROCESSING',
  CLEAR_HISTORY: 'betHistory/CLEAR_HISTORY',
  GET_SLOTS_BET_HISTORY_SUCCESS: 'betHistory/GET_SLOTS_BET_HISTORY_SUCCESS',
};

function clearHistory() {
  return async (dispatch) => {
    dispatch({ type: actionTypes.CLEAR_HISTORY });
  };
}

function getBetHistory(info) {
  return async (dispatch, getState, extra) => {
    if (!info.target_id) return;
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
    const { api } = extra;
    const locale = getState().locale.locale;
    const response = await api.betHistory.getBetHistory(info);
    // eslint-disable-next-line no-prototype-builtins
    const errorMessage = locale.hasOwnProperty(response.codeStatus)
      ? locale[response.codeStatus]
      : locale.defaultMessage;
    if (response.success) {
      dispatch({ type: actionTypes.GET_SLOTS_BET_HISTORY_SUCCESS, payload: response.data });
    } else {
      dispatch(addNotify(errorMessage, 'error'));
    }
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };
}

export { actionTypes, getBetHistory, clearHistory };
